import { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import FileItem from './FileItem';

const FileGalleryPreview = ({ files, playingId, setPlayingId, onImageClick }) => {
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [touchStarted, setTouchStarted] = useState(false);

  if (!files || files.length === 0) return null;

  const handleTouchStart = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setTouchStarted(true);
  };

  const handleTouchEnd = (event, actionFn) => {
    event.preventDefault();
    event.stopPropagation();
    if (touchStarted) {
      actionFn();
    }
    setTouchStarted(false);
  };

  const selectedFile = files[selectedIdx];

  return (
    <Box sx={{ mb: 2 }}>
      {/* Preview Box */}
      <Box sx={{ mb: 1, minHeight: 120, display: 'flex', justifyContent: 'center' }}
        onClick={() => onImageClick && onImageClick(files, selectedIdx)}>
        <FileItem
          file={selectedFile}
          playingId={playingId}
          setPlayingId={setPlayingId}
        />
      </Box>
      {/* Thumbnails/Icons */}
      {files.length > 1 && (
        <Box
          sx={{
            //width: isScrollable ? `${visibleIconCount * iconWidth}px` : "auto",
            width: '100px',
            minWidth: '100%',
            maxWidth: '100%',
            //overflowX: isScrollable ? "auto" : "hidden",
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            display: 'flex',
            //justifyContent: isScrollable ? "flex-start" : "center",
            justifyContent: 'space-evenly',
          }}
        >
          <Box
            sx={{
              display: 'inline-flex',
              gap: 1,
            }}
          >
            {files.map((file, idx) => (
              <IconButton
                key={file.id || file.mid || idx}
                onClick={() => {
                  // Only handle click if no touch events occurred
                  setTimeout(() => {
                    if (!touchStarted) {
                      setSelectedIdx(idx);
                    }
                  }, 50);
                }}
                onTouchStart={handleTouchStart}
                onTouchEnd={(e) => handleTouchEnd(e, () => setSelectedIdx(idx))}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                sx={{
                  border: idx === selectedIdx ? '2px solid #1976d2' : '1px solid #ccc',
                  background: idx === selectedIdx ? '#e3f2fd' : '#fff',
                  borderRadius: 2,
                  p: 0.5,
                  width: 40,
                  height: 40,
                  flexShrink: 0,
                  touchAction: 'manipulation',
                  WebkitTouchCallout: 'none',
                  WebkitUserSelect: 'none',
                  WebkitTapHighlightColor: 'transparent',
                  userSelect: 'none',
                }}
              >
                {file.thumbnail ? (
                  <img
                    src={file.thumbnail}
                    alt=""
                    style={{
                      width: 32,
                      height: 32,
                      objectFit: 'cover',
                      borderRadius: 2,
                    }}
                  />
                ) : (
                  <FileItem file={file} getIconOnly />
                )}
              </IconButton>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FileGalleryPreview;